module.exports = __webpack_public_path__ + "img/pharmacist.3669a77a.png";